import React, { useCallback, useEffect, useState } from 'react'
import { Route, Routes, Link, useNavigate  } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, Accordion, AccordionSummary, AccordionDetails, Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { MdKeyboardArrowDown } from "react-icons/md";
import {GiHamburgerMenu} from 'react-icons/gi';
import { MdOutlineClose} from 'react-icons/md';
import dashboardMenus from '../../utils/dashboardMenus';
import { AdminAuthConfig, BasicConfig, ThemeConfig, MenuConfig, PopUpConfig, ContConfig, FaqConfig, MemberConfig, PointConfig, BoardConfig, BoardGroupConfig, OneToOneConfig, ItemConfig, ItemGroupConfig, ItemAdviceConfig, ItmeQtyConfig, IncomConfig, ItemMainConfig, MainPopUpConfig, OrderListConfig, OrderListPrintConfig, ItemListPrintConfig, ShopConfig } from './dashMenu/index'
import { BoardAdd, BoardEdit, BoardGroupAdd, BoardGroupEdit, ContAdd, ContEdit, GroupAdd, GroupEdit, ItemAdd, ItemEdit, MemberAdd, MemberEdit, OrderEdit } from './detailPages/index'
import SmsBasic from './dashMenu/SmsBasic';
import ItemAdviceEdit from './detailPages/ItemAdviceEdit';
import axios from 'axios';
import { ImHome } from 'react-icons/im'
import PopUpConfig2 from './dashMenu/popupConfig2';
import { useDispatch } from 'react-redux';
import { setItemPageInit } from '../../redux/itemPageSlice';

const useStyles = makeStyles((theme)=>({
    dashboardMainBox: {
        fontFamily:[
            'Noto Sans KR'
        ],

        [theme.breakpoints.down(1025)]: {
        }
        
    },
    pcNavDiv: {
        height:'95px',
        background:'#D5D5D5',

        [theme.breakpoints.down(1025)]: {
            display:'none'
        }
    },
    mobileDiv:{
        display:'none',
        position:'relative',
        background:'#383A3F',
        height:'50px',

        [theme.breakpoints.down(1025)]: {
            display:'block',
        }
    },
    opennav:{
        display:'none',
        fontSize:'30px',
        position:'absolute',
        top:'10%',
        left:'2%',
        color:'#fff',

        [theme.breakpoints.down(1025)]: {
            display:'block',            
        }
    },
    closeNav:{
        cursor:'pointer',
        zIndex:'99999',
        color:'#fff',
        fontSize:'25px',
        textAlign:'right',
        [theme.breakpoints.down(1025)]: {
            
        } 
    },
    mobileNavDiv:{
        display:'none',
        
        [theme.breakpoints.down(1025)]: {
            display:'block',
            position:'fixed',
            top:'0px',
            left:'0',
            background:'#383A3F',
            width:'250px',
            height:'100%',
            zIndex:'9'
        }
    },
    toggleDiv:{
        position:'fixed',
        top:0,
        bottom:0,
        left:0,
        right:0,
        backgroundColor: 'rgba( 0.5, 0.5, 0.5, 0.5 )',
        overflowY:'auto', 
        overflowX:'hidden',
    },
    titleDiv: {
        padding:'15px 35px 10px 35px',
        borderBottom:'1px solid #444',
        background:'#383A3F',
        color:'#fff',
        display:'flex',
        justifyContent:'space-between',
    },
    titleDivH2:{
        fontSize:'19px',
        textShadow:'1px 1px 2px #555',
    },
    homeDiv:{
        
    },
    homeH1:{
        fontSize:'19px',
        textShadow:'1px 1px 2px #555',
        cursor:'pointer'
    },
    mobileHomeH1:{
        fontSize:'25px',
        textShadow:'1px 1px 2px #555',
        cursor:'pointer',
        color:'#fff',
        textAlign:'center',
        marginTop:'50px',
    },
    mobileTitleDiv:{
        height: 50,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        textAlign:'center',
    },
    mobileTitleDivH2:{
        fontSize:'18px',
        color:'#fff',
        textShadow:'1px 1px 2px #777',
    },
    row:{
        maxWidth:'1280px', 
        padding:'10px', 
    },
    pcMenu:{
        display:'flex',
        paddingLeft:'30px', 
    },
    pcmdIconH3:{
        transition:'all 5s',
        fontSize:'16px',  
        width: '140px',
        textAlign:'center',
        position:'relative',
        '&:hover':{
            cursor: "pointer",
            '& $pcDetailBox':{
                display:'block',                
            },
        },
    },
    pcDetailBox:{
        display:'none',
        padding:'12px',
        borderRadius:'5px',
        background:'#fff',
        width: '140px',
        position:'absolute',
        top:'100%',
        left:'50%',
        transform:'translateX(-50%)',
        zIndex:'9',
        fontSize:'15px',
        fontWeight:'500',
        border:'2px solid #555'
    },
    pcMenuDetailButton:{
        transition:'all 0.5s',
        borderBottom:'1px solid #D5D5D5',
        padding:'5px 0',
        textAlign:'center', 
        '&:hover':{
            background:'#4C4C4C',
            color:'#fff',
            borderRadius:'5px',
        },   
    },
    sideMenuDiv:{
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',  
    },
    sideMenu: {
        width: '200px',
    },
    accordionbox: {
        marginTop: 10,
        boxShadow: 'rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px',
    },
    accordionDetailBox: {
        display: 'flex',
        flexDirection: 'column',
    },
    mdIcon:{
        fontSize:'20px',
        color:'#555'
    },
    mdIconH3:{

        [theme.breakpoints.down(833)]: {
            
        }
    },
    menuDetailButton: {
        cursor: 'pointer',
        borderBottom: '1px solid #EBEDEF',
        color: '#566573',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 5,
        marginBottom: 5,
        paddingTop: 5,
        paddingBottom: 5,
        fontSize:'13px',
        "&:hover": {
            borderRadius: 5,
            border: 0,
            backgroundColor: '#555',
            color: '#FFFAF0',
            transition: 'all 0.5s'
        }
    },
    cont: {
        width: '100%',
        height: '100vh',
    },
    
}));

const DashboardMain = ({setAdmin}) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const navigate = useNavigate();
    const [dialog, setDialog] = useState('');
    const [toggleMenu, setToggleMenu] = useState(false);
    const [userInfo, setUserInfo] = useState();
    const dispatch = useDispatch()

    // const getJwtAuth = useCallback(async() => {
    //     try {
    //         const res = await axios.get('/api/user/jwtAuthUser/')
    //         if(!res.data.success){
    //             setDialog('인증을 실패 하였습니다.')
    //             window.location.replace(window.location.href.split('DashboardMain')[0]);
    //             return 
    //         }else{
    //             setUserInfo(res.data.result)
    //         }
    //     } catch (e) {
    //         console.log(e)
    //     }
    // }, [])
    
    useEffect(() => {
        setAdmin(true)
        // getJwtAuth()
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        if(userInfo){
            if(userInfo['mb_level'] !== 10){
                setDialog('권한이 없습니다.')
                window.location.replace(window.location.href.split('DashboardMain')[0]);
            }
        }
    }, [userInfo])

    const toggleNav = () => {
        setToggleMenu(!toggleMenu)
    }


    return (
        <div className={classes.dashboardMainBox}>
            <div className={classes.pcNavDiv}>
                <div className={classes.titleDiv}>
                    <h2 className={classes.titleDivH2}>
                        ADMINISTRATOR
                    </h2>
                    <div className={classes.homeDiv}>
                        <h1 
                            className={classes.homeH1}
                            onClick={() => {
                                window.location.replace(window.location.href.split('DashboardMain')[0]);
                            }}
                        >
                            <ImHome />
                        </h1>
                    </div>
                </div>
                <div className={classes.row}>
                    <div className={classes.pcMenu}>
                        {dashboardMenus.map((item, index) => (
                            <div key={index} className={classes.pcBox}>
                                <div className={classes.pcMdIconH3nDiv}>
                                    <h3 className={classes.pcmdIconH3}>{item[0]}
                                        <div className={classes.pcDetailBox}>
                                            {item[1].map((item, index) => (
                                                    <div
                                                        onClick={()=> {
                                                            if (item.path === '/itemConfig'){
                                                                dispatch(setItemPageInit())
                                                            } 
                                                        }}
                                                    >
                                                    <Link key={index} to={`/DashboardMain${item.path}`}>
                                                        <p 
                                                            key={index} 
                                                            className={classes.pcMenuDetailButton}
                                                        >
                                                            {item.name}
                                                        </p>
                                                    </Link>
                                                    </div>
                                                )
                                                
                                            )}
                                        </div>
                                    </h3>
                                    
                                </div>   
                                
                            </div>
                        ))}
                        <div 
                            onClick={() => {
                                navigate('memberEdit')
                            }}
                        >
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.mobileDiv}>
                <div className={classes.opennavDiv}>
                    <div className={classes.opennav} 
                            onClick={toggleNav} 
                        >
                            <GiHamburgerMenu/>
                    </div>
                    
                </div>
                
                {(toggleMenu && (
                    <div>
                        
                        
                        <div className={classes.toggleDiv}></div>
                        <div className={classes.mobileNavDiv}>
                            <div className={classes.closeNav} onClick={() => {setToggleMenu(false)}}>
                                <MdOutlineClose />
                            </div>
                            <div className={classes.mobileTitleDiv}>
                                <h2 className={classes.mobileTitleDivH2}>
                                    ADMINISTRATOR
                                </h2>
                            </div>
                            <div className={classes.sideMenuDiv}>
                                <div className={classes.sideMenu}>
                                    {dashboardMenus.map((item, index) => (
                                        <div key={index} className={classes.accordionbox}>
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<MdKeyboardArrowDown  className={classes.mdIcon}/>}
                                                    aria-controls="panel1a-content"
                                                >
                                                    <h3 className={classes.mdIconH3}>{item[0]}</h3>
                                                </AccordionSummary>
                                                <AccordionDetails >
                                                    <div className={classes.accordionDetailBox}>
                                                        {item[1].map((item, index) => (
                                                                <div
                                                                    onClick={() => {
                                                                        if (item.path === '/itemConfig'){
                                                                            dispatch(setItemPageInit())
                                                                        } 
                                                                    }}
                                                                >
                                                                    <Link 
                                                                        key={index} 
                                                                        to={`/DashboardMain${item.path}`}
                                                                        onClick={() => setToggleMenu(false)}
                                                                    >
                                                                        <h3 
                                                                            key={index} 
                                                                            className={classes.menuDetailButton}
                                                                        >
                                                                            {item.name}
                                                                        </h3>
                                                                    </Link>
                                                                </div>
                                                            )) 
                                                        }
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div>
                                    ))}
                                    <div 
                                    onClick={() => {
                                        navigate('memberEdit')
                                    }}
                                    >
                                    </div>
                                </div>
                                
                            </div>
                            <div>
                                    <h1 
                                        className={classes.mobileHomeH1}
                                        onClick={() => {
                                            window.location.replace(window.location.href.split('DashboardMain')[0]);
                                        }}
                                    >
                                        <ImHome />
                                    </h1>
                                </div>
                        </div>
                    </div>
                ))}

            </div>
            
            <div className={classes.cont}>
                <Routes>
                    <Route exact path="basicConfig" element={<BasicConfig />} />
                    <Route exact path="adminAuthConfig" element={<AdminAuthConfig />} />
                    <Route exact path="themeConfig" element={<ThemeConfig />} />
                    <Route exact path="menuConfig" element={<MenuConfig />} />
                    <Route exact path="popUpConfig" element={<PopUpConfig />} />
                    <Route exact path="popUpConfig2" element={<PopUpConfig2 />} />
                    <Route exact path="contConfig" element={<ContConfig />} />
                    <Route exact path="faqConfig" element={<FaqConfig />} />
                    <Route exact path="memberConfig" element={<MemberConfig />} />
                    <Route exact path="pointConfig" element={<PointConfig />} />
                    <Route exact path="boardConfig" element={<BoardConfig />} />
                    <Route exact path="boardGroupConfig" element={<BoardGroupConfig />} />
                    <Route exact path="oneToOneConfig" element={<OneToOneConfig />} />
                    <Route exact path="ShopConfig" element={<ShopConfig />} />
                    <Route exact path="itemConfig" element={<ItemConfig setAdmin={setAdmin} />} />
                    <Route exact path="itemGroupConfig" element={<ItemGroupConfig />} />
                    <Route exact path="itemAdviceConfig" element={<ItemAdviceConfig />} />
                    <Route exact path="itmeQtyConfig" element={<ItmeQtyConfig />} />
                    <Route exact path="incomConfig" element={<IncomConfig />} />
                    <Route exact path="itemMainConfig" element={<ItemMainConfig />} />
                    <Route exact path="mainPopUpConfig" element={<MainPopUpConfig />} />
                    <Route exact path="orderListConfig" element={<OrderListConfig />} />
                    <Route exact path="orderListPrintConfig" element={<OrderListPrintConfig />} />
                    <Route exact path="itemListPrintConfig" element={<ItemListPrintConfig />} />
                    <Route exact path="SmsBasic" element={<SmsBasic />} />

                    {/* 상세 페이지 */}
                    <Route exact path="boardAdd" element={<BoardAdd />} />
                    <Route exact path="boardEdit" element={<BoardEdit />} />
                    <Route exact path="boardGroupAdd" element={<BoardGroupAdd />} />
                    <Route exact path="boardGroupEdit" element={<BoardGroupEdit />} />
                    <Route exact path="contAdd" element={<ContAdd />} />
                    <Route exact path="contEdit" element={<ContEdit />} />
                    <Route exact path="groupAdd" element={<GroupAdd />} />
                    <Route exact path="groupEdit" element={<GroupEdit />} />
                    <Route exact path="itemAdd" element={<ItemAdd />} />
                    <Route exact path="itemEdit" element={<ItemEdit />} />
                    <Route exact path="memberAdd" element={<MemberAdd />} />
                    <Route exact path="memberEdit" element={<MemberEdit />} />
                    <Route exact path="orderEdit" element={<OrderEdit />} />
                    <Route exact path="itemAdviceEdit" element={<ItemAdviceEdit />} />
                </Routes>

            </div>

            <Dialog
                open={dialog === '' ? false : true}
                onClose={() => setDialog('')}
            >
                <DialogTitle id="alert-dialog-title">
                {dialog}
                </DialogTitle>
                <DialogActions>
                <Button onClick={() => setDialog('')} autoFocus>
                    확인
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default DashboardMain
